"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SectionContext = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _lodash = _interopRequireDefault(require("lodash"));

var _color = _interopRequireDefault(require("color"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _Info = _interopRequireDefault(require("../Info"));

var _Popover = _interopRequireDefault(require("../Popover"));

var _Checkbox = _interopRequireDefault(require("../form/Checkbox"));

var _ChevronButton = _interopRequireDefault(require("../button/ChevronButton"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var icons = _interopRequireWildcard(require("../../toolkit/icons"));

var _ImageColumn = _interopRequireDefault(require("./table/column/ImageColumn"));

var _CodeColumn = _interopRequireDefault(require("./table/column/CodeColumn"));

var _LinkColumn = _interopRequireDefault(require("./table/column/LinkColumn"));

var _BasicColumn = _interopRequireDefault(require("./table/column/BasicColumn"));

var _LabelColumn = _interopRequireDefault(require("./table/column/LabelColumn"));

var _SwitchColumn = _interopRequireDefault(require("./table/column/SwitchColumn"));

var _BooleanColumn = _interopRequireDefault(require("./table/column/BooleanColumn"));

var _NumeralColumn = _interopRequireDefault(require("./table/column/NumeralColumn"));

var _DecimalColumn = _interopRequireDefault(require("./table/column/DecimalColumn"));

var _ObjectIdColumn = _interopRequireDefault(require("./table/column/ObjectIdColumn"));

var _MarkdownColumn = _interopRequireDefault(require("./table/column/MarkdownColumn"));

var _CurrencyColumn = _interopRequireDefault(require("./table/column/CurrencyColumn"));

var _DatetimeColumn = _interopRequireDefault(require("./table/column/DatetimeColumn"));

var _TextInputColumn = _interopRequireDefault(require("./table/column/TextInputColumn"));

var _PercentageColumn = _interopRequireDefault(require("./table/column/PercentageColumn"));

var _TableColumnPicker = _interopRequireDefault(require("./table/TableColumnPicker"));

var _FixtureRow = _interopRequireDefault(require("./table/FixtureRow"));

var _FixtureCell = _interopRequireDefault(require("./table/FixtureCell"));

var _MobileTable = _interopRequireDefault(require("./table/mobile/MobileTable"));

var _BatchActionSection = _interopRequireDefault(require("./table/BatchActionSection"));

var _TableSectionHeader = _interopRequireDefault(require("./table/section/TableSectionHeader"));

var _TableActionButton = _interopRequireWildcard(require("./table/section/TableActionButton"));

var _device = require("../../toolkit/device");

var _localization = require("../../toolkit/localization");

var _class, _descriptor, _descriptor2, _temp, _class3, _class4, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _class5, _temp2;

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var SectionContext = (_class = (_temp = /*#__PURE__*/function () {
  function SectionContext(config, table) {
    (0, _classCallCheck2["default"])(this, SectionContext);
    this.table = void 0;
    this.config = void 0;
    (0, _initializerDefineProperty2["default"])(this, "rowSelectionToggled", _descriptor, this);
    (0, _initializerDefineProperty2["default"])(this, "onRowExpandToggled", _descriptor2, this);
    this.config = config;
    this.table = table;
  }

  (0, _createClass2["default"])(SectionContext, [{
    key: "cellStyle",
    value: function cellStyle(params) {
      var surfaceLightest = this.table.context.theming.theme.surfaceLightest;
      var row = params.row,
          index = params.index,
          value = params.value,
          column = params.column;
      var _this$config = this.config,
          cellStyle = _this$config.cellStyle,
          rowStyle = _this$config.rowStyle;
      var selectedBackgroundColor = this.selectedBackgroundColor;
      var selected = this.isRowSelected(index);
      var userCellStyle = cellStyle && cellStyle({
        row: row,
        index: index,
        value: value
      });
      var userRowStyle = rowStyle && rowStyle({
        row: row,
        index: index
      });
      var columnStyles = column && {
        width: column.width,
        minWidth: column.minWidth
      };
      var otherStyles = {
        backgroundColor: selected ? selectedBackgroundColor : surfaceLightest
      };
      return (0, _styling.css)(columnStyles, otherStyles, userRowStyle, userCellStyle);
    }
  }, {
    key: "canRowExpand",
    value: function canRowExpand(row, index) {
      var _this$config2 = this.config,
          rowExpands = _this$config2.rowExpands,
          onRowExpandToggled = _this$config2.onRowExpandToggled;
      return rowExpands != null && !!rowExpands(row, index) && onRowExpandToggled != null;
    }
  }, {
    key: "isRowExpanded",
    value: function isRowExpanded(index) {
      var expandedRows = this.config.expandedRows || [];
      return expandedRows.includes(index);
    }
  }, {
    key: "isRowSelected",
    value: function isRowSelected(index) {
      var selectedRowIndeces = this.selectedRowIndeces;
      return selectedRowIndeces.includes(index);
    }
  }, {
    key: "applicableActions",
    value: function applicableActions(rowContext) {
      var row = rowContext.row;
      var actions = this.config.actions;

      if (actions == null) {
        return [];
      }

      return actions.filter(function (a) {
        var _a$canApplyToRow;

        return ((_a$canApplyToRow = a.canApplyToRow) === null || _a$canApplyToRow === void 0 ? void 0 : _a$canApplyToRow.call(a, row)) || a.showWhenInactive;
      });
    }
  }, {
    key: "canSelectRow",
    value: function canSelectRow(row, index) {
      var _this$config3 = this.config,
          actions = _this$config3.actions,
          canSelectRow = _this$config3.canSelectRow;
      var hasApplicableAction = actions != null && actions.some(function (action) {
        var _action$canApplyToRow;

        return action.canBatch && ((_action$canApplyToRow = action.canApplyToRow) === null || _action$canApplyToRow === void 0 ? void 0 : _action$canApplyToRow.call(action, row));
      });

      if (hasApplicableAction) {
        return true;
      }

      if (canSelectRow != null) {
        return canSelectRow({
          row: row,
          index: index
        });
      }

      return false;
    }
  }, {
    key: "data",
    get: function get() {
      return this.config.data || [];
    }
  }, {
    key: "renderExpanded",
    get: function get() {
      return this.config.renderExpanded;
    }
  }, {
    key: "selectableRowIndeces",
    get: function get() {
      var _this = this;

      return this.data.map(function (row, index) {
        return [row, index];
      }).filter(function (_ref) {
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
            row = _ref2[0],
            index = _ref2[1];

        return _this.canSelectRow(row, index);
      }).map(function (_ref3) {
        var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
            _ = _ref4[0],
            index = _ref4[1];

        return index;
      });
    }
  }, {
    key: "selectedBackgroundColor",
    get: function get() {
      var primary = this.table.context.theming.theme.primary;
      var color = new _color["default"](primary);
      return color.alpha(0.1).toString();
    }
  }, {
    key: "canRenderExpandColumn",
    get: function get() {
      var _this2 = this;

      var _this$config4 = this.config,
          data = _this$config4.data,
          rowExpands = _this$config4.rowExpands,
          onRowExpandToggled = _this$config4.onRowExpandToggled;

      if (!rowExpands || !onRowExpandToggled || data == null) {
        return false;
      }

      return data.some(function (row, index) {
        return _this2.canRowExpand(row, index);
      });
    }
  }, {
    key: "hasSelectableRows",
    get: function get() {
      return this.selectableRowIndeces.length > 0;
    }
  }, {
    key: "selectedRowIndeces",
    get: function get() {
      var selectedRows = this.config.selectedRows;
      return selectedRows || [];
    }
  }, {
    key: "selectedRows",
    get: function get() {
      var data = this.data,
          selectedRowIndeces = this.selectedRowIndeces;
      return selectedRowIndeces.map(function (index) {
        return data[index];
      });
    }
  }, {
    key: "numRowsSelected",
    get: function get() {
      var selectedRowIndeces = this.selectedRowIndeces;
      return selectedRowIndeces.length;
    }
  }, {
    key: "batchableActions",
    get: function get() {
      var actions = this.config.actions;

      if (!actions) {
        return [];
      }

      return actions.filter(function (action) {
        return action.canBatch;
      });
    }
  }, {
    key: "activeBatchableActions",
    get: function get() {
      var _this3 = this;

      return this.batchableActions.filter(function (action) {
        if (action.batchOnly) {
          return true;
        }

        return _this3.selectedRowIndeces.length > 0 && _this3.selectedRowIndeces.every(function (rowIndex) {
          var _action$canApplyToRow2;

          var row = _this3.data[rowIndex];
          return (_action$canApplyToRow2 = action.canApplyToRow) === null || _action$canApplyToRow2 === void 0 ? void 0 : _action$canApplyToRow2.call(action, row);
        });
      });
    }
  }]);
  return SectionContext;
}(), _temp), ((0, _applyDecoratedDescriptor2["default"])(_class.prototype, "data", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "data"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "renderExpanded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "renderExpanded"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "selectableRowIndeces", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectableRowIndeces"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "selectedBackgroundColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedBackgroundColor"), _class.prototype), _descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "rowSelectionToggled", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (args) {
      var row = args.row,
          index = args.index,
          section = args.section;
      var onRowSelectionToggled = _this4.config.onRowSelectionToggled;

      if (onRowSelectionToggled == null) {
        return;
      }

      onRowSelectionToggled({
        row: row,
        index: index,
        selected: !section.isRowSelected(index)
      });
    };
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onRowExpandToggled", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function (rowContext) {
      var row = rowContext.row,
          index = rowContext.index;
      var onRowExpandToggled = _this5.config.onRowExpandToggled;

      if (_this5.canRowExpand(row, index) && onRowExpandToggled) {
        onRowExpandToggled(index, !_this5.isRowExpanded(index));
      }
    };
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "canRenderExpandColumn", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "canRenderExpandColumn"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasSelectableRows", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasSelectableRows"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "selectedRowIndeces", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedRowIndeces"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "selectedRows", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedRows"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "numRowsSelected", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "numRowsSelected"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "batchableActions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "batchableActions"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "activeBatchableActions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "activeBatchableActions"), _class.prototype)), _class);
exports.SectionContext = SectionContext;
var MAX_VISIBLE_COLUMNS = 11;
var EXPAND_ARROW_CELL_WIDTH = 20;
var SELECT_CELL_WIDTH = 40;
var DEFAULT_ACTION_COLUMN_WIDTH = 175;
var DEFAULT_ACTION_CONTENT_DROPDOWN_WIDTH = 190;
var DEFAULT_HEADER_HEIGHT = 20;
var DEFAULT_ROW_HEIGHT = 50;

var FixtureColumn = function FixtureColumn(props) {
  return /*#__PURE__*/_react["default"].createElement(_BasicColumn["default"], (0, _extends2["default"])({
    columnKey: "none"
  }, props));
};

var TableSection = function TableSection(props) {
  return null;
};
/* Purely virtual, no actual render */


var InternalChildren = [TableSection, _FixtureRow["default"], _FixtureCell["default"]];

var Table = (0, _mobxReact.observer)(_class3 = (_class4 = (_temp2 = _class5 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Table, _Component);

  var _super = _createSuper(Table);

  function Table(props) {
    var _this6;

    (0, _classCallCheck2["default"])(this, Table);
    _this6 = _super.call(this, props);
    _this6.context = void 0;
    (0, _initializerDefineProperty2["default"])(_this6, "currentIndex", _descriptor3, (0, _assertThisInitialized2["default"])(_this6));
    (0, _initializerDefineProperty2["default"])(_this6, "visibleColumns", _descriptor4, (0, _assertThisInitialized2["default"])(_this6));
    (0, _initializerDefineProperty2["default"])(_this6, "loading", _descriptor5, (0, _assertThisInitialized2["default"])(_this6));
    (0, _initializerDefineProperty2["default"])(_this6, "scrollerOffsetX", _descriptor6, (0, _assertThisInitialized2["default"])(_this6));
    (0, _initializerDefineProperty2["default"])(_this6, "scrollerOffsetY", _descriptor7, (0, _assertThisInitialized2["default"])(_this6));
    (0, _initializerDefineProperty2["default"])(_this6, "scrollerRef", _descriptor8, (0, _assertThisInitialized2["default"])(_this6));
    (0, _initializerDefineProperty2["default"])(_this6, "showActionShadow", _descriptor9, (0, _assertThisInitialized2["default"])(_this6));
    _this6.disposables = [];
    _this6.mounted = false;
    _this6.navigator = void 0;

    _this6.alignmentStyle = function (align) {
      switch (align) {
        case "left":
          return {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center"
          };

        case "right":
          return {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            justifyContent: "center"
          };

        case "stretch":
          return {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            justifyContent: "center"
          };

        default:
          return {
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          };
      }
    };

    _this6.renderCell = function (params) {
      var cell = params.cell,
          columnProps = params.columnProps,
          row = params.row,
          index = params.index,
          section = params.section;
      return /*#__PURE__*/_react["default"].cloneElement(columnProps.component, _objectSpread(_objectSpread({}, columnProps), {}, {
        row: row,
        index: index,
        value: cell,
        section: section
      }));
    };

    _this6.renderColumnPicker = function () {
      return /*#__PURE__*/_react["default"].createElement(_TableColumnPicker["default"], {
        className: (0, _styling.css)(_this6.styles.columnPicker),
        columns: _this6.allColumns.map(function (col) {
          var component = col.component,
              others = (0, _objectWithoutProperties2["default"])(col, ["component"]);
          return others;
        }),
        onColumnToggled: function onColumnToggled(_ref5) {
          var columnKey = _ref5.columnKey;
          return _this6.onColumnVisibilityToggled(columnKey);
        },
        selectedKeys: _this6.visibleColumns
      });
    };

    (0, _initializerDefineProperty2["default"])(_this6, "onSelectAllToggled", _descriptor10, (0, _assertThisInitialized2["default"])(_this6));
    _this6.navigator = new _providers.LegoNavigator(_this6.context);
    var maxVisibleColumns = _this6.props.maxVisibleColumns;
    _this6.visibleColumns = _this6.allColumns.slice(0, maxVisibleColumns) // a.slice(0, undefined) returns a
    .map(function (c) {
      return c.columnKey;
    });
    return _this6;
  }

  (0, _createClass2["default"])(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this7 = this;

      var deviceStore = _device.DeviceStore.instance();

      this.disposables.push((0, _mobx.reaction)(function () {
        return [_this7.scrollerOffsetX, deviceStore.screenInnerWidth];
      }, function (_ref6) {
        var _ref7 = (0, _slicedToArray2["default"])(_ref6, 1),
            scrollerOffsetX = _ref7[0];

        var scrollerRef = _this7.scrollerRef;

        if (scrollerRef == null) {
          return;
        }

        var endOffset = scrollerRef.scrollWidth - scrollerRef.clientWidth - 3;
        _this7.showActionShadow = scrollerRef.scrollLeft < endOffset;
      }, {
        fireImmediately: true
      }));
      this.mounted = true; // Fix for shadow appearing on page load even though the scroll offset is
      // zero.

      setTimeout(function () {
        if (_this7.mounted) {
          _this7.onScrollerScrolled();
        }
      }, 1000);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.disposables.forEach(function (dispose) {
        return dispose();
      });
      this.disposables = [];
      this.mounted = false;
    }
  }, {
    key: "onScrollerScrolled",
    value: function onScrollerScrolled() {
      var scrollerRef = this.scrollerRef;

      if (scrollerRef == null) {
        return;
      }

      this.scrollerOffsetX = scrollerRef.scrollLeft;
      this.scrollerOffsetY = scrollerRef.scrollTop + scrollerRef.offsetHeight <= scrollerRef.scrollHeight ? scrollerRef.scrollTop : scrollerRef.scrollHeight - scrollerRef.offsetHeight;
    }
  }, {
    key: "onColumnVisibilityToggled",
    value: function onColumnVisibilityToggled(key) {
      var index = this.visibleColumns.indexOf(key);

      if (index < 0) {
        this.visibleColumns.push(key);
      } else {
        this.visibleColumns.splice(index, 1);
      }
    }
  }, {
    key: "renderColumnPickerButton",
    value: function renderColumnPickerButton() {
      if (!this.showColumnPicker) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("th", {
        className: (0, _styling.css)(this.styles.columnPickerHeader)
      }, /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
        popoverContent: this.renderColumnPicker,
        position: "bottom right"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.columnPickerButton)
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "ellipsis-h"
      }))));
    }
  }, {
    key: "renderNoData",
    value: function renderNoData() {
      var loading = this.loading,
          tableIsEmpty = this.tableIsEmpty,
          noDataMessage = this.props.noDataMessage;

      if (loading || !tableIsEmpty) {
        return null;
      }

      var message = noDataMessage;

      if (typeof noDataMessage === "function") {
        message = noDataMessage();
      }

      return /*#__PURE__*/_react["default"].createElement("section", {
        className: (0, _styling.css)(this.styles.noDataMessage)
      }, message);
    }
  }, {
    key: "renderExpandArrowColumn",
    value: function renderExpandArrowColumn(rowContext) {
      if (!this.canRenderExpandColumn) {
        return null;
      }

      var row = rowContext.row,
          index = rowContext.index,
          section = rowContext.section;
      var expandable = section.canRowExpand(row, index);
      var expanded = section.isRowExpanded(index);
      return /*#__PURE__*/_react["default"].createElement("td", {
        className: this.cellStyle({
          row: row,
          index: index,
          section: section
        })
      }, expandable && /*#__PURE__*/_react["default"].createElement(_ChevronButton["default"], {
        onClick: function onClick() {
          if (expandable) {
            section.onRowExpandToggled(rowContext);
          }
        },
        direction: expanded ? "down" : "right",
        size: 14
      }));
    }
  }, {
    key: "renderRow",
    value: function renderRow(rowContext) {
      var _this8 = this;

      var row = rowContext.row,
          index = rowContext.index,
          section = rowContext.section;
      var _section$config = section.config,
          renderExpanded = _section$config.renderExpanded,
          rowStyle = _section$config.rowStyle,
          onClickRow = _section$config.onClickRow,
          _section$config$doubl = _section$config.doubleClickToSelectRow,
          doubleClickToSelectRow = _section$config$doubl === void 0 ? true : _section$config$doubl;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: "fragment-".concat(index)
      }, /*#__PURE__*/_react["default"].createElement("tr", {
        key: "row-".concat(index),
        onClick: onClickRow && function () {
          return onClickRow(rowContext);
        },
        onDoubleClick: doubleClickToSelectRow ? function () {
          return section.rowSelectionToggled(rowContext);
        } : undefined,
        className: (0, _styling.css)(this.styles.row, rowStyle && rowStyle(rowContext))
      }, this.renderRowSelectionColumn(rowContext), this.renderExpandArrowColumn(rowContext), this.tableColumns.map(function (column, columnIndex) {
        var keyPrefix = columnIndex + "-"; // _.get() is needed here because of the nested dynamic access.
        // Can't be accomplished with optional chaining.
        // eslint-disable-next-line local-rules/no-unnecessary-use-of-lodash

        var cell = _lodash["default"].get(row, column.columnKey);

        return /*#__PURE__*/_react["default"].createElement("td", {
          key: "".concat(keyPrefix).concat(column.columnKey),
          className: _this8.cellStyle(_objectSpread(_objectSpread({}, rowContext), {}, {
            value: cell,
            column: column
          }))
        }, _this8.renderCell(_objectSpread(_objectSpread({}, rowContext), {}, {
          cell: cell,
          columnProps: column
        })));
      }), this.canRenderActionsColumn && this.renderActionColumn(rowContext), this.showColumnPicker && /*#__PURE__*/_react["default"].createElement("td", {
        className: (0, _styling.css)(this.styles.cell)
      }, "  ")), section.isRowExpanded(index) && renderExpanded != null && /*#__PURE__*/_react["default"].createElement("tr", {
        key: "row-".concat(index, "-expanded"),
        className: (0, _styling.css)(this.styles.row)
      }, /*#__PURE__*/_react["default"].createElement("td", {
        colSpan: this.columnCount,
        className: (0, _styling.css)(this.styles.expandedRowContent)
      }, renderExpanded(row))));
    }
  }, {
    key: "onColumnClicked",
    value: function onColumnClicked(column) {
      var sortOrder = column.sortOrder,
          onSortToggled = column.onSortToggled;

      if (sortOrder == null || onSortToggled == null) {
        return;
      }

      var nextSortOrder = sortOrder === "asc" ? "desc" : "asc";
      onSortToggled(nextSortOrder);
    }
  }, {
    key: "renderRowSelectionColumn",
    value: function renderRowSelectionColumn(rowContext) {
      var section = rowContext.section,
          row = rowContext.row,
          index = rowContext.index;
      var hasBatchableActions = this.sections.some(function (section) {
        return section.batchableActions.length > 0;
      });

      if (!hasBatchableActions && section.selectableRowIndeces.length === 0) {
        return null;
      }

      var canSelect = section.canSelectRow(row, index);
      return /*#__PURE__*/_react["default"].createElement("td", {
        className: (0, _styling.css)(this.cellStyle({
          section: section,
          row: row,
          index: index
        }), {
          width: SELECT_CELL_WIDTH,
          minWidth: SELECT_CELL_WIDTH,
          overflow: "hidden"
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.rowSelectCheckbox)
      }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
        onChange: function onChange() {
          return section.rowSelectionToggled(rowContext);
        },
        checked: section.isRowSelected(index),
        disabled: !canSelect
      })));
    }
  }, {
    key: "renderActionColumn",
    value: function renderActionColumn(rowContext) {
      var _this9 = this;

      var surfaceLightest = this.context.theming.theme.surfaceLightest;
      var row = rowContext.row,
          section = rowContext.section,
          index = rowContext.index;
      var _section$config2 = section.config,
          actions = _section$config2.actions,
          renderRowActions = _section$config2.renderRowActions,
          selectedBackgroundColor = section.selectedBackgroundColor;

      if (actions == null) {
        return null;
      }

      var selected = section.isRowSelected(index);
      var applicableActions = section.applicableActions(rowContext).filter(function (action) {
        return !action.batchOnly;
      });
      var rowStyle = section.config.rowStyle;
      var userRowStyle = rowStyle && rowStyle({
        row: row,
        index: index
      });
      var otherStyles = {
        backgroundColor: selected ? selectedBackgroundColor : surfaceLightest
      };
      var className = (0, _styling.css)(this.styles.actionColumnCell, otherStyles, userRowStyle);

      if (applicableActions.length == 0) {
        // Render blank cell.
        return /*#__PURE__*/_react["default"].createElement("td", {
          className: className
        });
      }

      var applyAction = /*#__PURE__*/function () {
        var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(action) {
          var _ref9, apply, href;

          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _ref9 = action, apply = _ref9.apply;

                  if (!(apply != null)) {
                    _context.next = 5;
                    break;
                  }

                  _context.next = 4;
                  return apply([row]);

                case 4:
                  return _context.abrupt("return");

                case 5:
                  href = (0, _TableActionButton.getHref)(action.href, [row]);

                  if (!href) {
                    _context.next = 9;
                    break;
                  }

                  _context.next = 9;
                  return _this9.handleNavigate(href);

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function applyAction(_x) {
          return _ref8.apply(this, arguments);
        };
      }();

      return /*#__PURE__*/_react["default"].createElement("td", {
        className: className
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.actionColumnCellInner, {
          flex: 1
        })
      }, renderRowActions ? renderRowActions({
        actions: applicableActions,
        row: row,
        apply: applyAction
      }) : /*#__PURE__*/_react["default"].createElement(_TableActionButton["default"], {
        style: {
          minWidth: 0.8 * this.actionColumnWidth
        },
        padding: "5px 5px",
        row: rowContext,
        section: section,
        dropDownContentWidth: this.actionDropdownContentWidth
      })));
    }
  }, {
    key: "renderBatchActionsRow",
    value: function renderBatchActionsRow() {
      if (this.tableIsEmpty) {
        return null;
      }

      var activeBatchActions = this.activeBatchActions,
          selectedRows = this.selectedRows;

      if (activeBatchActions.length == 0) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(_BatchActionSection["default"], {
        className: (0, _styling.css)(this.styles.batchActionsRow),
        actions: activeBatchActions,
        selectedRows: selectedRows
      });
    }
  }, {
    key: "cellStyle",
    value: function cellStyle(params) {
      var section = params.section,
          args = (0, _objectWithoutProperties2["default"])(params, ["section"]);
      return (0, _styling.css)(this.styles.cell, section.cellStyle(args));
    }
  }, {
    key: "renderColumnHeader",
    value: function renderColumnHeader(column) {
      var _this10 = this;

      var renderHeader = column.renderHeader,
          description = column.description,
          descriptionPopoverMinWidth = column.descriptionPopoverMinWidth,
          align = column.align,
          titleProp = column.title,
          sortOrder = column.sortOrder;
      var canClick = sortOrder != null;
      var title = typeof titleProp === "function" ? titleProp() : titleProp;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: _objectSpread({
          textAlign: column.align ? column.align : "left",
          minWidth: column.minWidth
        }, this.alignmentStyle(column.align || "left"))
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.rowCenterItems),
        style: {
          cursor: canClick ? "pointer" : "default"
        },
        onClick: function onClick() {
          if (canClick) {
            _this10.onColumnClicked(column);
          }
        }
      }, renderHeader != null ? renderHeader() : title, description && /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
        position: "top ".concat(align || "center"),
        popoverMaxWidth: 350,
        popoverMinWidth: descriptionPopoverMinWidth,
        popoverFontSize: 14,
        popoverContent: description
      }, /*#__PURE__*/_react["default"].createElement(_Info["default"], {
        className: (0, _styling.css)(this.styles.headerInfoIcon)
      })), this.renderColumnSort(column)));
    }
  }, {
    key: "renderColumnSort",
    value: function renderColumnSort(column) {
      var sortOrder = column.sortOrder;

      if (sortOrder == null || sortOrder === "not-applied") {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("img", {
        src: icons.arrowUp,
        className: (0, _styling.css)(this.styles.sortIcon, sortOrder === "asc" ? this.styles.sortIconUp : this.styles.sortIconDown),
        alt: "change sort order",
        draggable: false
      });
    }
  }, {
    key: "renderSection",
    value: function renderSection(section) {
      var _this11 = this;

      var data = section.data,
          _section$config3 = section.config,
          sectionKey = _section$config3.sectionKey,
          header = _section$config3.header;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: sectionKey
      }, header != null && /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        colSpan: this.columnCount
      }, /*#__PURE__*/_react["default"].createElement(_TableSectionHeader["default"], {
        section: section
      }))), data.map(function (row, rIdx) {
        return _this11.renderRow({
          row: row,
          index: rIdx,
          section: section
        });
      }));
    }
  }, {
    key: "renderMobileTable",
    value: function renderMobileTable() {
      return /*#__PURE__*/_react["default"].createElement(_MobileTable["default"], {
        sections: this.sections,
        columns: this.tableColumns
      });
    }
  }, {
    key: "renderTable",
    value: function renderTable() {
      var _this12 = this;

      var tableIsEmpty = this.tableIsEmpty;

      if (tableIsEmpty) {
        return null;
      }

      var _LocalizationStore = new _localization.LocalizationStore(this.context),
          i18n = _LocalizationStore.i18n;

      var hasBatchableActions = this.sections.some(function (section) {
        return section.batchableActions.length > 0;
      });
      var _this$props = this.props,
          hideSelectAll = _this$props.hideSelectAll,
          stickyTableHeight = _this$props.stickyTableHeight;
      var tbodyProps = stickyTableHeight && {
        style: {
          height: stickyTableHeight + this.scrollerOffsetY
        }
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.scroller),
        ref: function ref(r) {
          return _this12.scrollerRef = r;
        },
        onScroll: function onScroll() {
          return _this12.onScrollerScrolled();
        }
      }, /*#__PURE__*/_react["default"].createElement("table", {
        className: (0, _styling.css)(this.styles.table)
      }, /*#__PURE__*/_react["default"].createElement("tbody", tbodyProps, /*#__PURE__*/_react["default"].createElement("tr", null, (this.hasSelectableRows || hasBatchableActions) && /*#__PURE__*/_react["default"].createElement("th", {
        className: (0, _styling.css)(this.styles.headerItem)
      }, !hideSelectAll && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.selectAllContainer)
      }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
        onChange: function onChange() {
          _this12.onSelectAllToggled();
        },
        checked: this.selectAllToggled,
        disabled: !this.hasSelectableRows
      }))), this.canRenderExpandColumn && /*#__PURE__*/_react["default"].createElement("th", {
        className: (0, _styling.css)(this.styles.headerItem),
        style: {
          width: EXPAND_ARROW_CELL_WIDTH,
          minWidth: EXPAND_ARROW_CELL_WIDTH
        }
      }), this.tableColumns.map(function (column) {
        return /*#__PURE__*/_react["default"].createElement("th", {
          key: column.columnKey,
          className: (0, _styling.css)(_this12.styles.headerItem)
        }, _this12.renderColumnHeader(column));
      }), this.canRenderActionsColumn && /*#__PURE__*/_react["default"].createElement("th", {
        className: (0, _styling.css)(this.styles.actionColumnHeader),
        style: {
          textAlign: "center"
        }
      }, i18n("Action")), this.renderColumnPickerButton()), this.sections.map(function (section) {
        return _this12.renderSection(section);
      }), this.fixtureRows)));
    }
  }, {
    key: "handleNavigate",
    value: function () {
      var _handleNavigate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(href) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (href) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.next = 4;
                return this.navigator.navigate(href);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleNavigate(_x2) {
        return _handleNavigate.apply(this, arguments);
      }

      return handleNavigate;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          style = _this$props2.style;
      var rootCSS = (0, _styling.css)(this.styles.root, style, className);

      var _DeviceStore$instance = _device.DeviceStore.instance(),
          isVerySmallScreen = _DeviceStore$instance.isVerySmallScreen;

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: rootCSS
      }, this.renderBatchActionsRow(), isVerySmallScreen ? this.renderMobileTable() : this.renderTable(), this.renderNoData());
    }
  }, {
    key: "hasSelectableRows",
    get: function get() {
      return this.sections.some(function (section) {
        return section.hasSelectableRows;
      });
    }
  }, {
    key: "columnCount",
    get: function get() {
      var tableColumns = this.tableColumns,
          hasSelectableRows = this.hasSelectableRows,
          canRenderExpandColumn = this.canRenderExpandColumn,
          canRenderActionsColumn = this.canRenderActionsColumn;
      var hasBatchableActions = this.sections.some(function (section) {
        return section.batchableActions.length > 0;
      });
      return tableColumns.length + (canRenderExpandColumn ? 1 : 0) + (canRenderActionsColumn ? 1 : 0) + (hasSelectableRows || hasBatchableActions ? 1 : 0);
    }
  }, {
    key: "children",
    get: function get() {
      var children = this.props.children;
      return _react["default"].Children.toArray(children).filter(function (e) {
        return /*#__PURE__*/_react["default"].isValidElement(e);
      });
    }
  }, {
    key: "columnChildren",
    get: function get() {
      return this.children.filter(function (e) {
        return !InternalChildren.includes(e.type);
      });
    }
  }, {
    key: "sections",
    get: function get() {
      var _this13 = this;

      var userDefinedSections = this.children.filter(function (e) {
        return /*#__PURE__*/_react["default"].isValidElement(e) && e.type.name == TableSection.name;
      });

      if (userDefinedSections.length > 0) {
        return userDefinedSections.map(function (section) {
          return section.props;
        }).map(function (config) {
          return new SectionContext(config, _this13);
        });
      }

      var sectionConfig = _objectSpread(_objectSpread({}, this.props), {}, {
        sectionKey: "default"
      });

      return [new SectionContext(sectionConfig, this)];
    }
  }, {
    key: "fixtureRows",
    get: function get() {
      var _this14 = this;

      return this.children.filter(function (e) {
        return e.type == _FixtureRow["default"];
      }).map(function (child) {
        if (! /*#__PURE__*/_react["default"].isValidElement(child)) {
          return null;
        }

        var fixtureChild = child;
        return /*#__PURE__*/_react["default"].cloneElement(fixtureChild, _objectSpread(_objectSpread({}, fixtureChild.props), {}, {
          className: (0, _styling.css)(_this14.styles.row, fixtureChild.props.className, fixtureChild.props.style),
          columnCount: _this14.columnCount,
          cellPadding: _this14.cellPadding
        }));
      });
    }
  }, {
    key: "allColumns",
    get: function get() {
      return _react["default"].Children.map((0, _toConsumableArray2["default"])(this.columnChildren), function (child) {
        return _objectSpread(_objectSpread({}, child.props), {}, {
          component: child
        });
      }) || [];
    }
  }, {
    key: "tableColumns",
    get: function get() {
      var _this15 = this;

      return this.allColumns.filter(function (column) {
        return _this15.visibleColumns.includes(column.columnKey);
      });
    }
  }, {
    key: "showColumnPicker",
    get: function get() {
      var maxVisibleColumns = this.props.maxVisibleColumns;
      return maxVisibleColumns ? this.allColumns.length > maxVisibleColumns : false;
    }
  }, {
    key: "numRowsSelected",
    get: function get() {
      var sections = this.sections;
      return sections.reduce(function (total, section) {
        return section.numRowsSelected + total;
      }, 0);
    }
  }, {
    key: "selectedRows",
    get: function get() {
      var sections = this.sections;
      var total = [];

      var _iterator = _createForOfIteratorHelper(sections),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var section = _step.value;
          total = [].concat((0, _toConsumableArray2["default"])(total), (0, _toConsumableArray2["default"])(section.selectedRows));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return total;
    }
  }, {
    key: "canRenderActionsColumn",
    get: function get() {
      var _this$props3 = this.props,
          actions = _this$props3.actions,
          data = _this$props3.data;

      if (!actions || data == null) {
        return false;
      }

      return data.some(function (row, index) {
        return actions.some(function (a) {
          var _a$canApplyToRow2;

          return !a.batchOnly && (((_a$canApplyToRow2 = a.canApplyToRow) === null || _a$canApplyToRow2 === void 0 ? void 0 : _a$canApplyToRow2.call(a, row)) || a.showWhenInactive);
        });
      });
    }
  }, {
    key: "canRenderExpandColumn",
    get: function get() {
      return this.sections.some(function (section) {
        return section.canRenderExpandColumn;
      });
    }
  }, {
    key: "selectAllToggled",
    get: function get() {
      return this.sections.some(function (section) {
        return section.selectedRowIndeces.length > 0;
      });
    }
  }, {
    key: "tableIsEmpty",
    get: function get() {
      var data = this.sections.reduce(function (total, section) {
        return [].concat((0, _toConsumableArray2["default"])(total), (0, _toConsumableArray2["default"])(section.data));
      }, []);
      return data.length == 0 && this.fixtureRows.length == 0;
    }
  }, {
    key: "activeBatchActions",
    get: function get() {
      var _this16 = this;

      var sections = this.sections;
      return sections.reduce(function (actions, section) {
        var selectedRows = section.selectedRows;
        return [].concat((0, _toConsumableArray2["default"])(actions), (0, _toConsumableArray2["default"])(section.activeBatchableActions.map(function (action) {
          return _objectSpread(_objectSpread({
            perform: function () {
              var _perform = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
                var _ref10, apply, _ref11, href, batchLink;

                return _regenerator["default"].wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _this16.loading = true;
                        _ref10 = action, apply = _ref10.apply;
                        _ref11 = action, href = _ref11.href;

                        if (!(apply != null)) {
                          _context3.next = 7;
                          break;
                        }

                        _context3.next = 6;
                        return apply(selectedRows);

                      case 6:
                        (0, _mobx.runInAction)(function () {
                          _this16.loading = false;
                        });

                      case 7:
                        if (!(href != null)) {
                          _context3.next = 17;
                          break;
                        }

                        if (!(typeof href === "function")) {
                          _context3.next = 14;
                          break;
                        }

                        _context3.next = 11;
                        return href(selectedRows);

                      case 11:
                        batchLink = _context3.sent;
                        _context3.next = 15;
                        break;

                      case 14:
                        if (typeof href === "string") {
                          batchLink = href;
                        }

                      case 15:
                        _context3.next = 17;
                        return _this16.handleNavigate(batchLink);

                      case 17:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              function perform() {
                return _perform.apply(this, arguments);
              }

              return perform;
            }(),
            name: (0, _TableActionButton.getActionName)(action, selectedRows)
          }, (0, _TableActionButton.getActionDescription)(action, selectedRows)), {}, {
            originalAction: action
          });
        })));
      }, []);
    }
  }, {
    key: "requiresFixedRowHeight",
    get: function get() {
      var rowHeight = this.props.rowHeight;
      return rowHeight != null || this.canRenderActionsColumn;
    }
  }, {
    key: "cellPadding",
    get: function get() {
      var cellPadding = this.props.cellPadding;

      if (this.requiresFixedRowHeight) {
        return "0px 14px";
      }

      return cellPadding || "14px 14px";
    }
  }, {
    key: "rowHeight",
    get: function get() {
      var rowHeight = this.props.rowHeight;

      if (this.requiresFixedRowHeight) {
        return rowHeight || DEFAULT_ROW_HEIGHT;
      }

      return null;
    }
  }, {
    key: "actionColumnWidth",
    get: function get() {
      var canRenderActionsColumn = this.canRenderActionsColumn,
          actionColumnWidth = this.props.actionColumnWidth;

      if (canRenderActionsColumn) {
        return actionColumnWidth || DEFAULT_ACTION_COLUMN_WIDTH;
      }

      return 0;
    }
  }, {
    key: "actionDropdownContentWidth",
    get: function get() {
      var canRenderActionsColumn = this.canRenderActionsColumn,
          actionDropdownContentWidth = this.props.actionDropdownContentWidth;

      if (canRenderActionsColumn) {
        return actionDropdownContentWidth || DEFAULT_ACTION_CONTENT_DROPDOWN_WIDTH;
      }

      return 0;
    }
  }, {
    key: "actionColumnShadow",
    get: function get() {
      var borderPrimary = this.context.theming.theme.borderPrimary; // Handle boxShadow for Firefox because firefox UI is weird when
      // `position: sticky` for <table>

      var _DeviceStore$instance2 = _device.DeviceStore.instance(),
          isFirefox = _DeviceStore$instance2.isFirefox;

      if (isFirefox) {
        if (this.showActionShadow) {
          return "-9px 1.5px 5px 0px ".concat(borderPrimary);
        }

        return "0 -2px 1px -1px ".concat(borderPrimary);
      }

      return this.showActionShadow ? "-9px 0px 5px 0px rgba(0,0,0,0.022)" : undefined;
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$context$theming = this.context.theming,
          _this$context$theming2 = _this$context$theming.theme,
          borderPrimary = _this$context$theming2.borderPrimary,
          textBlack = _this$context$theming2.textBlack,
          surfaceLightest = _this$context$theming2.surfaceLightest,
          surfaceLight = _this$context$theming2.surfaceLight,
          fonts = _this$context$theming.fonts;
      var _this$props4 = this.props,
          fixLayout = _this$props4.fixLayout,
          stickyTableHeight = _this$props4.stickyTableHeight,
          hideHeaderRowBackground = _this$props4.hideHeaderRowBackground;

      var _DeviceStore$instance3 = _device.DeviceStore.instance(),
          isSmallScreen = _DeviceStore$instance3.isSmallScreen;

      var loading = this.loading,
          _this$props5 = this.props,
          _this$props5$hideBord = _this$props5.hideBorder,
          hideBorder = _this$props5$hideBord === void 0 ? isSmallScreen : _this$props5$hideBord,
          overflowY = _this$props5.overflowY;
      var keyframes = {
        from: {
          transform: "translate3d(0, -10px, 0)",
          opacity: 0
        },
        to: {
          transform: "translate3d(0, 0, 0)",
          opacity: 1
        }
      };
      var rowBorder = "solid 1px ".concat(borderPrimary);
      return _aphrodite.StyleSheet.create({
        root: {
          opacity: loading ? 0.4 : 1,
          borderRadius: !hideBorder ? 4 : undefined,
          boxShadow: !hideBorder ? "0 2px 4px 0 rgba(175, 199, 209, 0.2)" : undefined,
          border: !hideBorder ? "solid 1px rgba(175, 199, 209, 0.5)" : undefined,
          position: "relative",
          backgroundBlendMode: "darken",
          backgroundColor: surfaceLight,
          fontFamily: fonts.regular
        },
        table: {
          width: "100%",
          borderSpacing: 0,
          borderCollapse: "collapse",
          tableLayout: fixLayout ? "fixed" : undefined
        },
        headerItem: {
          position: "sticky",
          top: 0,
          backgroundColor: hideHeaderRowBackground ? surfaceLightest : surfaceLight,
          border: "none",
          cursor: "default",
          color: textBlack,
          userSelect: "none",
          textRendering: "optimizeSpeed",
          padding: "12px",
          fontSize: 15,
          fontFamily: fonts.semibold,
          wordWrap: "break-word",
          whiteSpace: "normal",
          "first-child": {
            paddingLeft: 12
          },
          borderBottom: rowBorder,
          backgroundBlendMode: "darken",
          background: hideHeaderRowBackground ? surfaceLightest : surfaceLight
        },
        columnPickerHeader: {
          position: "sticky",
          top: 0,
          border: "none",
          cursor: "pointer",
          maxWidth: 58,
          borderLeft: "solid 1px #dfe3e8",
          background: hideHeaderRowBackground ? surfaceLightest : surfaceLight,
          zIndex: 10
        },
        chevronCell: {
          padding: "0px 10px",
          width: EXPAND_ARROW_CELL_WIDTH,
          minWidth: EXPAND_ARROW_CELL_WIDTH
        },
        contentRow: {},
        row: {
          height: this.rowHeight || undefined,
          backgroundColor: surfaceLightest
        },
        expandedRowContent: {
          animationName: [keyframes],
          animationDuration: "400ms"
        },
        columnPickerButton: {
          height: "100%",
          padding: 10,
          textAlign: "center",
          fontFamily: fonts.bold,
          border: "none",
          transition: "all 0.3s linear",
          transform: "scale(1.2, 1.2)"
        },
        columnPicker: {
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
          padding: "8px 13px 8px 13px"
        },
        noDataMessage: {
          display: "flex",
          border: "none",
          cursor: "default",
          color: "#4a4a4a",
          userSelect: "none",
          backgroundColor: "white",
          textAlign: "center",
          padding: "15px 0px",
          fontSize: 16,
          alignItems: "center",
          justifyContent: "center",
          flex: 1
        },
        batchActionsRow: {
          padding: "2px ".concat(EXPAND_ARROW_CELL_WIDTH, "px"),
          height: 50,
          borderBottom: rowBorder
        },
        selectAllContainer: {
          display: "flex",
          flexDirection: "row",
          width: SELECT_CELL_WIDTH,
          alignItems: "center",
          justifyContent: "center"
        },
        rowSelectCheckbox: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center"
        },
        headerInfo: {
          marginLeft: 4
        },
        sortIcon: {
          height: 16,
          transition: "transform 0.2s linear",
          marginLeft: 2,
          alignSelf: "center"
        },
        sortIconUp: {
          marginBottom: 2
        },
        sortIconDown: {
          transform: "rotate(180deg)"
        },
        cell: {
          border: "none",
          textRendering: "optimizeSpeed",
          padding: this.cellPadding,
          whiteSpace: "nowrap",
          "first-child": {
            paddingLeft: 14
          },
          borderTop: "1px solid ".concat(borderPrimary)
        },
        actionColumnHeader: {
          position: "sticky",
          right: 0,
          zIndex: 10,
          top: 0,
          width: this.actionColumnWidth,
          height: DEFAULT_HEADER_HEIGHT,
          padding: "14px 8px",
          border: "none",
          cursor: "default",
          color: textBlack,
          userSelect: "none",
          textRendering: "optimizeSpeed",
          fontSize: 16,
          fontFamily: fonts.semibold,
          backgroundBlendMode: "darken",
          background: hideHeaderRowBackground ? surfaceLightest : surfaceLight,
          boxShadow: this.actionColumnShadow || undefined,
          transition: "box-shadow 0.3s ease-in-out"
        },
        actionColumnCell: {
          position: "sticky",
          right: 0,
          top: 0,
          height: this.rowHeight || undefined,
          width: this.actionColumnWidth,
          borderTop: "solid 1px rgba(175, 199, 209, 0.5)",
          boxShadow: this.actionColumnShadow || undefined,
          transition: "box-shadow 0.3s ease-in-out"
        },
        actionColumnCellInner: {
          padding: "0px 8px",
          height: this.rowHeight || undefined,
          width: this.actionColumnWidth,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        scroller: {
          borderRadius: !hideBorder ? 4 : undefined,
          overflowX: "auto",
          overflowY: overflowY ? "visible" : undefined,
          height: stickyTableHeight
        },
        rowCenterItems: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        },
        headerInfoIcon: {
          marginLeft: 7
        }
      });
    }
  }]);
  return Table;
}(_react.Component), _class5.contextType = _providers.LegoContext, _class5.Column = _BasicColumn["default"], _class5.LinkColumn = _LinkColumn["default"], _class5.CodeColumn = _CodeColumn["default"], _class5.LabelColumn = _LabelColumn["default"], _class5.ImageColumn = _ImageColumn["default"], _class5.SwitchColumn = _SwitchColumn["default"], _class5.BooleanColumn = _BooleanColumn["default"], _class5.NumeralColumn = _NumeralColumn["default"], _class5.DecimalColumn = _DecimalColumn["default"], _class5.FixtureColumn = FixtureColumn, _class5.DatetimeColumn = _DatetimeColumn["default"], _class5.MarkdownColumn = _MarkdownColumn["default"], _class5.CurrencyColumn = _CurrencyColumn["default"], _class5.ObjectIdColumn = _ObjectIdColumn["default"], _class5.TextInputColumn = _TextInputColumn["default"], _class5.PercentageColumn = _PercentageColumn["default"], _class5.ColumnComponents = [_LinkColumn["default"], _CodeColumn["default"], _LabelColumn["default"], _ImageColumn["default"], _BasicColumn["default"], _SwitchColumn["default"], _BooleanColumn["default"], _NumeralColumn["default"], FixtureColumn, _DecimalColumn["default"], _DatetimeColumn["default"], _MarkdownColumn["default"], _CurrencyColumn["default"], _ObjectIdColumn["default"], _TextInputColumn["default"], _PercentageColumn["default"]], _class5.InternalChildren = [TableSection, _FixtureRow["default"], _FixtureCell["default"]], _class5.Section = TableSection, _class5.FixtureRow = _FixtureRow["default"], _class5.FixtureCell = _FixtureCell["default"], _class5.defaultProps = {
  data: [],
  noDataMessage: "No Data",
  maxVisibleColumns: MAX_VISIBLE_COLUMNS,
  highlightRowOnHover: false,
  rowHeight: DEFAULT_ROW_HEIGHT
}, _class5.propDoc = {}, _class5.demoRender = "\n<Table\n  actions={[\n    {\n      key: \"action\",\n      name: \"Action\",\n      apply: ([row]) => {\n        // onClick functionality goes here\n      },\n      canApplyToRow: _ => true\n    },\n    {\n      key: \"link\",\n      name: \"Link\",\n      href: \"https://google.com\",\n      canApplyToRow: _ => true\n    }\n  ]}\n  data={[\n    { gmv: 10, name: \"merchant A\", lateArrivalRate: 0.55, deliveryTime: 1, is_wish_express: true },\n    {\n      gmv: 200.232,\n      name: \"merchant B\",\n      lateArrivalRate: 0.33,\n      deliveryTime: 3,\n      is_wish_express: false\n    }\n]}>\n  <Table.Column\n    title={\"Merchant Name\"}\n    columnKey=\"name\"\n  />\n\n  <Table.CurrencyColumn\n    title={\"GMV\"}\n    columnKey=\"gmv\"\n    currencyCode=\"CNY\"\n    description={\"Some description of GMV\"}\n  />\n\n  <Table.BooleanColumn\n    title=\"Is Wish Express\"\n    columnKey=\"is_wish_express\"\n    description={\"Is the merchant enrolled in Wish Express\"}\n  />\n\n  <Table.DecimalColumn\n    title=\"Delivery Time\"\n    columnKey=\"deliveryTime\"\n    description={\"description of Delivery Time\"}\n  />\n</Table>\n", _class5.discussion = "\n  Tables present raw data sets and lend meaning to the data, while maintaining\n  that the data is readable, scannable, and easily comparable.\n  ", _temp2), (_descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "currentIndex", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "visibleColumns", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "loading", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "scrollerOffsetX", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor7 = (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "scrollerOffsetY", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor8 = (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "scrollerRef", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "showActionShadow", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "onScrollerScrolled", [_mobx.action], Object.getOwnPropertyDescriptor(_class4.prototype, "onScrollerScrolled"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "hasSelectableRows", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "hasSelectableRows"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "columnCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "columnCount"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "children", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "children"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "columnChildren", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "columnChildren"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "sections", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "sections"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "fixtureRows", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "fixtureRows"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "allColumns", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "allColumns"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "tableColumns", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "tableColumns"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "showColumnPicker", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "showColumnPicker"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "numRowsSelected", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "numRowsSelected"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "selectedRows", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "selectedRows"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "onColumnVisibilityToggled", [_mobx.action], Object.getOwnPropertyDescriptor(_class4.prototype, "onColumnVisibilityToggled"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "canRenderActionsColumn", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "canRenderActionsColumn"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "canRenderExpandColumn", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "canRenderExpandColumn"), _class4.prototype), _descriptor10 = (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "onSelectAllToggled", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this17 = this;

    return function () {
      var _iterator2 = _createForOfIteratorHelper(_this17.sections),
          _step2;

      try {
        var _loop = function _loop() {
          var section = _step2.value;
          var selectedRowIndeces = section.selectedRowIndeces,
              _section$config4 = section.config,
              onRowSelectionToggled = _section$config4.onRowSelectionToggled,
              data = _section$config4.data;

          if (onRowSelectionToggled == null) {
            return {
              v: void 0
            };
          }

          var selectAll = selectedRowIndeces.length === 0;
          (data || []).forEach(function (row, index) {
            if (section.canSelectRow(row, index)) {
              onRowSelectionToggled({
                row: row,
                index: index,
                selected: selectAll
              });
            }
          });
        };

        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _ret = _loop();

          if ((0, _typeof2["default"])(_ret) === "object") return _ret.v;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    };
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "selectAllToggled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "selectAllToggled"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "tableIsEmpty", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "tableIsEmpty"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "activeBatchActions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "activeBatchActions"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "requiresFixedRowHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "requiresFixedRowHeight"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "cellPadding", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "cellPadding"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "rowHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "rowHeight"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "actionColumnWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "actionColumnWidth"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "actionDropdownContentWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "actionDropdownContentWidth"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "actionColumnShadow", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "actionColumnShadow"), _class4.prototype), (0, _applyDecoratedDescriptor2["default"])(_class4.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class4.prototype, "styles"), _class4.prototype)), _class4)) || _class3;

var _default = Table;
exports["default"] = _default;